import type React from "react";

const Flow: React.FC = () => {
	const flowSteps = [
		{
			id: "intro",
			number: 1,
			title: "開始の挨拶と自己紹介",
			content: "まずは参加者同士、簡単な自己紹介と今日の目標を宣言します",
		},
		{
			id: "work-time-1",
			number: 2,
			title: "各自の作業時間（前半）",
			content: "各自の作業に集中する時間です",
		},
		{
			id: "break-time",
			number: 3,
			title: "休憩&経過報告",
			content: "休憩と途中経過を報告し合う時間です",
		},
		{
			id: "work-time-2",
			number: 4,
			title: "各自の作業時間（後半）",
			content: "さらに作業を進めていきます",
		},
		{
			id: "progress-report",
			number: 5,
			title: "進捗報告と振り返り",
			content: "進捗を報告し、振り返りを行います",
		},
		{
			id: "end",
			number: 6,
			title: "終了の挨拶",
			content: "最後に全員で挨拶をして終了です",
		},
	];

	return (
		<section className="py-16 bg-white">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">
					内容を見てみましょう
				</h2>
				<ol className="max-w-2xl mx-auto space-y-6">
					{flowSteps.map((step) => (
						<li
							key={step.id}
							className="bg-white rounded-lg shadow-md p-6 relative flex items-start"
						>
							<div className="absolute -top-3 -left-3 bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold">
								{step.number}
							</div>
							<div className="ml-6">
								<h3 className="text-xl font-semibold mb-2 text-blue-600">
									{step.title}
								</h3>
								<p className="text-gray-600">{step.content}</p>
							</div>
						</li>
					))}
				</ol>
			</div>
		</section>
	);
};

export default Flow;
